<template>
  <div v-if="Object.keys(courseInfo).length">
    <div class="ci_info">
      <div class="ci_info_box">
        <span>项目名称：</span><span>{{ courseInfo.title }}</span>
      </div>
      <div class="ci_info_box">
        <span>创建人：</span><span>{{ courseInfo.name }}</span>
      </div>
      <div class="ci_info_box">
        <span>协同人员：</span
        ><span>{{ teacher ? teacher : "无协同人员" }}</span>
      </div>
      <div class="ci_info_box2">
        <div>
          阶段<span>{{ tool.stage }}</span
          >个
        </div>
        <div>
          任务<span>{{ tool.task }}</span
          >个
        </div>
        <div>
          工具<span>{{ tool.tool }}</span
          >个
        </div>
      </div>
    </div>
    <div style="width: 90%; height: calc(100% - 130px); margin: 10px auto 0">
      <!-- <img src="../../assets/dataimage/1.png" style="width:90%" /> -->
      <div
        id="charts_canvas"
        class="echart"
        style="width: 100%; height: 100%"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["courseid"],
  data() {
    return {
      courseInfo: {},
      teacher: "",
      chartObj: null,
      tool: {
        stage: 0,
        task: 0,
        tool: 0,
      },
      option: {
        title: {
          text: "项目汇总",
          textStyle: {
            fontSize: 13,
            fontWeight: 0,
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "10%",
          right: "5%",
          bottom: "10%",
          top: "12%",
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: ["图片", "互动", "问答", "问卷", "视频"],
        },
        series: [
          {
            name: "个数",
            type: "bar",
            data: [10, 12, 5, 6, 7],
            barWidth: "40%",
            label: {
              show: true,
            },
          },
        ],
      },
    };
  },
  methods: {
    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          return 0;
          break;
      }
    },
    getInfo() {
      let params = {
        cid: this.courseid,
      };
      console.log(this.courseid);
      if (!this.courseid) {
        return;
      }
      this.ajax
        .get(this.$store.state.api + "getCourseInfo", params)
        .then((res) => {
          this.courseInfo = res.data[0][0];
          let teachers = res.data[1];
          let teacher = [];
          for (var i = 0; i < teachers.length; i++) {
            teacher.push(teachers[i].name);
          }
          this.teacher = teacher.join("、");

          let chapters = JSON.parse(res.data[0][0].chapters);
          var task = 0;
          var tool = 0;
          for (var i = 0; i < chapters.length; i++) {
            task += chapters[i].chapterInfo[0].taskJson.length;
            for (
              var j = 0;
              j < chapters[i].chapterInfo[0].taskJson.length;
              j++
            ) {
              tool += chapters[i].chapterInfo[0].taskJson[j].toolChoose.length;
            }
          }
          this.tool.stage = chapters.length;
          this.tool.task = task;
          this.tool.tool = tool;
          this.$nextTick(() => {
            this.setChart();
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setChart() {
      // 雷达图显示的标签
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        const chartObj = this.$echarts.init(
          //劳动课程
          this.$el.querySelector("#charts_canvas")
          //   document.getElementById("#charts_canvas")
        );
        let _array = [];
        for (var i = 0; i < 5; i++) {
          _array.push(this.randomNum(0, 15));
        }
        this.option.series[0].data = _array;
        // 初始化雷达图
        this.chartObj = chartObj;
        this.chartObj.setOption(this.option);
      });
      let _this = this;
      window.addEventListener("resize", () => {
        if (_this.chartObj) {
          _this.chartObj.resize();
        }
      });
    },
  },
  watch: {
    courseid(newValue, oldValue) {
      this.getInfo();
    },
  },
  created() {
    this.getInfo();
  },
};
</script>

<style scoped>
.ci_info {
  font-size: 14px;
}
.ci_info_box {
  width: 90%;
  margin: 0 auto;
  display: flex;
}
.ci_info_box span {
  white-space: nowrap;
}
.ci_info_box span + span {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ci_info_box + .ci_info_box {
  margin-top: 10px;
}
.ci_info_box2 {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-top: 10px;
  font-size: 16px;
  justify-content: space-between;
  color: rgb(15, 120, 187);
  align-items: center;
}
.ci_info_box2 div {
  display: flex;
  align-items: center;
}
.ci_info_box2 span {
  color: rgb(234, 146, 59);
  width: 30px;
  font-size: 25px;
  text-align: center;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/components/report/courseInfo.vue